import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';
import { CollectionBadge } from './components/collection-card-badge';

/** Renders the collection badge. Returns null when no collection badge data is present. */
export function CardCollectionBadge(): JSX.Element | null {
  const { collectionBadge } = useCardContext();

  if (!collectionBadge) {
    return null;
  }

  return (
    <Wrapper>
      <CollectionBadge {...collectionBadge} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: ${13 / 12};
  text-transform: ${({ theme }) => theme.customized.textTransforms.tags};
`;
